import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { Fab, Tooltip } from '@mui/material'
import { useInsightsEnabled } from 'hooks/use-insights-enabled'
import { useHistory, useLocation } from 'react-router-dom'

const INSIGHTS_ROUTE = '/insights'

const InsightsFab = () => {
  const { enabled } = useInsightsEnabled()
  const history = useHistory()
  const location = useLocation()

  if (!enabled || location.pathname === INSIGHTS_ROUTE) return null

  return (
    <Tooltip title="Agente de IA">
      <Fab
        onClick={() => history.push(INSIGHTS_ROUTE)}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1300,
          width: 56,
          height: 56,
          backgroundColor: '#3024E1',
          color: '#FFFFFF',
          boxShadow: '0 4px 12px rgba(48,36,225,0.3)',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          '&:hover': {
            backgroundColor: '#3024E1',
            transform: 'scale(1.05)',
            boxShadow: '0 6px 18px rgba(48,36,225,0.4)',
          },
        }}
      >
        <AutoAwesomeIcon sx={{ color: '#FFFFFF !important' }} />
      </Fab>
    </Tooltip>
  )
}

export default InsightsFab
